/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { action, observable } from 'mobx';

export default class BannerItem {
    layoutId;

    imageList = [];

    backUpImageList = [];

    textList = [];

    buttonList = [];

    urlList = [];

    backgroundColor;

    borderColor = [];

    appName;

    videoList = [];

    thumbNailImg;

    textColor;

    gradient;

    onAction;

    appData = {};

    ingestDescription = '';

    analytics = {};

    @observable
    loadBackUpImages = false;

    @action
    setBackUpImageList = (loadBackUpImages) => {
        this.loadBackUpImages = loadBackUpImages;
    }

    @action
    setAnalytics = (analytics) => {
        this.analytics = analytics;
    }

    changeToColor(colorText) {
        if (!colorText || colorText.startsWith('#')) {
            return colorText;
        }
        return `#${colorText}`;
    }

    updateBorderColor(borderColor) {
        const hashPrefixedBorderColors = [];
        if (!borderColor) {
            return hashPrefixedBorderColors;
        }
        borderColor.forEach((color) => {
            const hashPrefixedColor = this.changeToColor(color);
            hashPrefixedBorderColors.push(hashPrefixedColor);
        });
        return hashPrefixedBorderColors;
    }

    constructor({
        layoutId,
        imageList = [],
        textList = [],
        buttonList = [],
        urlList = [],
        appName,
        videoList = [],
        textColor,
        thumbNailImg,
        backgroundColor,
        borderColor,
        gradient,
        onAction,
        name,
        ingestDescription,
        appData,
        backUpImageList,
    }) {
        this.layoutId = layoutId;
        this.imageList = imageList;
        this.textList = textList;
        this.buttonList = buttonList;
        this.urlList = urlList;
        this.textColor = this.changeToColor(textColor);
        this.thumbNailImg = thumbNailImg;
        this.backgroundColor = this.changeToColor(backgroundColor);
        this.borderColor = this.updateBorderColor(borderColor);
        this.gradient = gradient;
        this.appName = appName;
        this.videoList = videoList;
        this.onAction = onAction;
        this.name = name;
        this.appData = appData;
        this.ingestDescription = ingestDescription;
        this.backUpImageList = backUpImageList;
    }
}
